module.exports = __webpack_public_path__ + "static/media/talia.0421c7b9.png";